module.exports = __webpack_public_path__ + "img/ds2.acb1de80.png";